import { registerSectionType } from "../../utils/sectionRegistry";
import { AccordionSection } from "../sectionComponents";

registerSectionType({
  type: "acordeon",
  label: "Acordeon",
  layout: "accordion",
  previewBlocks: ["Pregunta", "Pregunta", "Pregunta"],
  getDefaults: () => ({ type: "acordeon", title: "", description: "", itemsText: "", draft_title: "", draft_content: "" }),
  editorFields: [
    { key: "title", label: "Pregunta o titulo del item" },
    { key: "content", label: "Respuesta o contenido del item", input: "textarea", placeholder: "Escribe la respuesta aqui..." },
  ],
  itemLabel: "item",
  render: (section, index) => <AccordionSection section={section} index={index} />,
});
